import { render, staticRenderFns } from "./NJ-PH-Notice.vue?vue&type=template&id=e7964fb8&scoped=true&"
import script from "./NJ-PH-Notice.vue?vue&type=script&lang=js&"
export * from "./NJ-PH-Notice.vue?vue&type=script&lang=js&"
import style0 from "./NJ-PH-Notice.vue?vue&type=style&index=0&id=e7964fb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7964fb8",
  null
  
)

export default component.exports